export const typedEntries = <
  Type extends { [key: number | string | symbol]: any },
>(
  object: Type,
) => Object.entries(object) as [keyof Type, Type[keyof Type]][];
